/**
 * GLOBAL HELPER
 */
import * as lodash from 'lodash';
import qs from 'qs';
import { sanitize } from 'services/sanitize';
import { masterData } from 'services/master-data/master-data.service';
import { addLoading, removeLoading, removeAllLoading } from 'services/loading';

/**
 * Lodash is relatively big, but this app is client side render,
 * so it is ok to fetch common library on initial.
 */
window['_'] = lodash;

window['qs'] = qs;

window['sanitize'] = sanitize;

window['masterData'] = masterData;

window['addLoading'] = addLoading;

window['removeLoading'] = removeLoading;

window['removeAllLoading'] = removeAllLoading;
